import React from 'react';

const QuestionCard = ({ question, value, onAnswer }) => {
  const handleRatingClick = (rating) => {
    onAnswer(question.id, rating);

    // Add haptic feedback if supported
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }
  };

  return (
    <div className={`question-card ${value ? 'answered' : ''}`}>
      <p className="question-text">
        {question.text}
      </p>

      <div className="rating-buttons">
        {[1, 2, 3, 4, 5].map((rating) => (
          <button
            key={rating}
            type="button"
            className={`rating-btn ${value === rating ? 'selected' : ''}`}
            onClick={() => handleRatingClick(rating)}
            aria-label={`Értékelés: ${rating} pont`}
          >
            {rating}
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuestionCard;